import { Pipe, PipeTransform } from '@angular/core';
import memo from 'memo-decorator'
@Pipe({
  name: 'getDepartmentId',
  pure: true
})
export class GetDepartmentIdPipe implements PipeTransform {
  @memo()
  transform(value: any, args?: any): any {
    let scheduleObj : any = args;
    return  scheduleObj.getResourcesByIndex(value).resourceData.DepartmentGroupID; //args.groupIndex
  }

}
